export default __webpack_public_path__ + "static/media/trees-sun-shift-fast.e72eadb6.gif";